import {
  BarChartOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import {
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import { AppNavMenu } from '..';
import { useDemoStore } from 'src/pages/root/demo/store';
import { useGetCurrentPractitioner } from 'src/hooks/settings';

/** Phone triage module + permission to read calls (full Phone area). */
export function usePhoneTriageFullAccess(): boolean {
  const { isEntitled: hasPhone } = useFeatureEntitlements('phone-triage');
  const { isEntitled: hasCallRead } = usePermissionEntitlements('calls.read');
  return Boolean(hasPhone && hasCallRead);
}

/** Admin Call QA feature (may be granted without full phone triage). */
export function useCallQaNavAccess(): boolean {
  const { isEntitled: hasPhoneQa } = useFeatureEntitlements('phone-qa');
  const { isAdmin } = useGetCurrentPractitioner();
  return Boolean(hasPhoneQa && isAdmin);
}

export const usePhoneTriageNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isPhoneTriageDemoEntitled } =
    useFeatureEntitlements('phone-triage-demo');
  const { setDemoStoreState } = useDemoStore();
  const hasPhoneAccess = usePhoneTriageFullAccess();
  const hasPhoneQaAccess = useCallQaNavAccess();

  if (hasPhoneAccess) {
    return [
      {
        path: '/phone-triage',
        title: 'Phone',
        icon: <PhoneOutlined />,
        submenu: [
          {
            path: '/phone-triage/analytics',
            title: 'Analytics',
            icon: <BarChartOutlined />,
          },
          ...(hasPhoneQaAccess
            ? [
                {
                  path: '/phone-triage/call-qa',
                  title: 'Call QA',
                  icon: <CheckCircleOutlined />,
                },
              ]
            : []),
        ],
      },
    ];
  }

  if (hasPhoneQaAccess) {
    return [
      {
        path: '/phone-triage',
        title: 'Phone',
        icon: <PhoneOutlined />,
      },
    ];
  }

  if (isPhoneTriageDemoEntitled) {
    return [
      {
        path: '',
        title: 'Phone',
        icon: <PhoneOutlined />,
        onClick: () => {
          setDemoStoreState({ showPhoneTriageDemo: true });
        },
        showBadge: 'dot',
      },
    ];
  }

  return [];
};
